export function maskZero(num) {
    var numberWithZeroes = String(num);
    var counter = numberWithZeroes.length;   
    while(counter < 6) {  
      numberWithZeroes = "0" + numberWithZeroes;     
      counter++; 
    }  
    return numberWithZeroes;
}